<script>
export default {
  props: {
    tokenDecoded: {
      type: Object
    }
  },
  data() {
    return {
    }
  }
}
</script>
<template>
  <div>
    <v-row class="justify-center text-center">
      <v-col>
        <v-icon color="orange" size="74" class="icon_border_round"
        >mdi-account-multiple-plus</v-icon>
      </v-col>
    </v-row>
    <v-row>
      <v-col>{{ $t('component.profile.administrationManagement.invited.by') }}</v-col>
    </v-row>
    <v-row class="justify-center text-center">
      <v-col cols="auto"
      ><h2>{{ tokenDecoded.AdminEmail }}</h2></v-col>
    </v-row>
    <v-row>
      <v-col>{{ $t('component.profile.administrationManagement.invited.to') }}</v-col>
    </v-row>
    <v-row class="justify-center text-center">
      <v-col cols="auto"
      ><h2>{{ tokenDecoded.OrganizationName }}</h2></v-col   >
    </v-row>
  </div>
</template>
